import { useState, useRef, useEffect } from 'react';
import './Select.scss';

function Select({
  label,
  options = [],
  value,
  onChange,
  placeholder = 'Vyber možnosť...',
  required = false,
  disabled = false,
  error,
  className = '',
}) {
  const [isOpen, setIsOpen] = useState(false);
  const selectRef = useRef(null);

  const selectedOption = options.find((opt) => opt.value === value);

  // Close on outside click
  useEffect(() => {
    if (!isOpen) return;
    const handleClick = (e) => {
      if (selectRef.current && !selectRef.current.contains(e.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClick);
    return () => document.removeEventListener('mousedown', handleClick);
  }, [isOpen]);

  const handleSelect = (opt) => {
    if (opt.disabled) return;
    onChange?.(opt.value);
    setIsOpen(false);
  };

  return (
    <div className={`select ${className}`} ref={selectRef}>
      {label && <label className="select__label">{label}</label>}

      <div
        className={`select__control ${isOpen ? 'select__control--focused' : ''} ${
          disabled ? 'select__control--disabled' : ''
        } ${error ? 'select__control--error' : ''}`}
        onClick={() => !disabled && setIsOpen(!isOpen)}
      >
        <span className={`select__value ${!selectedOption ? 'select__placeholder' : ''}`}>
          {selectedOption ? selectedOption.label : placeholder}
        </span>
        <span className={`select__arrow ${isOpen ? 'select__arrow--open' : ''}`}>▼</span>
      </div>

      <div className={`select__dropdown ${isOpen ? 'select__dropdown--open' : ''}`}>
        {options.map((opt, i) => (
          <button
            key={i}
            type="button"
            className={`select__option ${opt.value === value ? 'select__option--selected' : ''} ${
              opt.disabled ? 'select__option--disabled' : ''
            }`}
            onClick={() => handleSelect(opt)}
          >
            {opt.label}
          </button>
        ))}
      </div>

      {error && <span className="select__error">{error}</span>}
    </div>
  );
}

export default Select;
